module.exports = __webpack_public_path__ + "img/6.bf2394e4.png";